<div
  *ngIf="loyaltyProgram"
  class="program-description-container rounded-md-b-mobile rounded-md-desktop"
  [ngSwitch]="getComponentRenderState()">
  <ng-container *ngSwitchCase="'content'">
    <h2
      class="loyalty-program-name m-0 mb-2"
      [attr.aria-label]="
        'accessibility.transfer_v2.program_description'
          | translate: { loyaltyProgram: loyaltyProgram.name }
      ">
      {{ loyaltyProgram.name }}
    </h2>

    <ng-container *ngTemplateOutlet="additionalInformation"> </ng-container>

    <p
      class="loyalty-program-description m-0"
      [innerHTML]="loyaltyProgram.description"></p>

    <rd-shared-link
      *ngIf="loyaltyProgram.pointsTransferCapability.detailsUrl"
      class="find-out-more mt-4"
      [text]="'transfer_v2.checkout.find_out_more' | translate"
      [path]="loyaltyProgram.pointsTransferCapability.detailsUrl.toString()"
      [isTargetBlank]="true"></rd-shared-link>
  </ng-container>

  <ng-container *ngSwitchCase="'loading'">
    <div class="description-item loading mb-4"></div>
    <div class="description-item loading mb-4"></div>
    <div class="description-item loading mb-0"></div>
  </ng-container>
</div>
